<template>
  <div style="text-align: left">
    <div class="list">订单详情</div>
    <div class="content">
      <div class="goods">
        <div style="flex:2;display: flex; ">
          <div class="search">
            <div>姓名：<el-input style="width:200px" disabled v-model="info.userName" clearable
                placeholder="姓名"></el-input>&nbsp;&nbsp;</div>
            <div>年级：<el-input style="width:200px" disabled v-model="info.grade" clearable
                placeholder="请选择"></el-input>&nbsp;&nbsp;
            </div>
            <div>班级：<el-input style="width:200px" disabled v-model="info.className" placeholder="班级"
                clearable></el-input>&nbsp;&nbsp;</div>
            <div>性别：<span
                style="color: #C0C4CC ;font-size: 14px; width:200px;display: inline-block; background-color: #F4F6F9; padding: 6px 15px;border-radius: 5px;box-sizing: border-box;border: 1px solid #E4E7ED;">{{
                  info.sex == 0 ? '女' : '男' }}</span>
              <!-- <el-input style="width:200px" disabled v-model="info.sex == 0 ? '女' : '男' " placeholder="性别"
                clearable></el-input>&nbsp;&nbsp; -->
            </div>
            <div>身高：<el-input style="width:200px" disabled v-model="info.height" placeholder="身高"
                clearable></el-input>&nbsp;&nbsp;
            </div>
            <div>体重：<el-input style="width:200px" disabled v-model="info.weight" placeholder="体重"
                clearable></el-input>&nbsp;&nbsp;
            </div>
            <!-- <div>胸围：<el-input style="width:200px" disabled v-model="info.bust" placeholder="胸围"
                clearable></el-input>&nbsp;&nbsp;
            </div>
            <div>腰围：<el-input style="width:200px" disabled v-model="info.waist" placeholder="腰围"
                clearable></el-input>&nbsp;&nbsp;
            </div>
            <div>臀围：<el-input style="width:200px" disabled v-model="info.hip" placeholder="臀围"
                clearable></el-input>&nbsp;&nbsp;
            </div> -->
            <div>
              <el-button type="primary" @click="returnPage" plain>返回</el-button>
              <el-button type="primary" @click="deliveryOfGoods">发货</el-button>
            </div>
            <!-- <div>备注：<el-input style="width:200px" placeholder="备注" clearable></el-input>&nbsp;&nbsp;</div> -->
          </div>
        </div>
      </div>
      <br />
      <div class="global-table-box">
        <el-table :data="tableData" border style="width: 100%" :cell-style="{}" header-align="center">
          <el-table-column type="index" width="50" label="序号" header-align="center" align="center">
          </el-table-column>
          <el-table-column prop="batchName" label="批次名称" width="300" header-align="center" align="center">
          </el-table-column>
          <el-table-column prop="goodsName" label="商品名称" header-align="center" width="200" align="center">
          </el-table-column>
          <el-table-column prop="orderCode" label="订单编号" width="200" header-align="center" align="center">
          </el-table-column>
          <el-table-column prop="setAmount" label="商品单价(元)" width="200" header-align="center" align="center">
          </el-table-column>
          <el-table-column prop="remark" label="商品规格" width="200" header-align="center" align="center">
          </el-table-column>
          <el-table-column prop="goodsModel" label="商品款式" width="200" header-align="center" align="center">
          </el-table-column>
          <el-table-column prop="logisticsType" label="配送方式" width="200" header-align="center" align="center">
          </el-table-column>
          <el-table-column prop="logisticsCode" label="物流单号" width="200" header-align="center" align="center">
            <template slot-scope="scope" v-if="scope.row.logisticsType === '快递到家'">
              <span v-if="scope.row.logisticsCode === null">未发货</span>
              <span v-else>{{ scope.row.logisticsCode }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" header-align="center" align="center" fixed="right" width="200">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="openDialog(scope.row)">修改信息</el-button>
              <el-button type="text" size="small" @click="showProgressBox(scope.row)">物流信息</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="block">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="orderInfo.pageNum"
          :page-size="orderInfo.pageSize" layout="prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>


      <el-dialog title="修改" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
        <div v-if="!(goodsInfo.isOver)" style="color: red; margin: 10px 0 ;">批次已结束</div>
        <div>商品名称：<el-input style="width:200px" disabled v-model="goodsInfo.goodsName" clearable></el-input>
        </div>
        <br>
        <div>商品规格：<el-input style="width:200px" v-model="goodsInfo.remark" placeholder="身高" clearable></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="confirmModification">确 定</el-button>
        </span>
      </el-dialog>

      <el-dialog title="物流进度" :visible.sync="progressVisible" width="50%">
        <div style="margin-bottom:20px;font-size: 16px;">运单号：<span style="color: black;">{{ activities.mailNo }}</span></div>
        <el-timeline :reverse="true">
          <el-timeline-item v-for="(activity, index) in activities.routes" :key="index" :timestamp="activity.acceptTime"  :color="activity.color">
            {{ activity.acceptAddress }} <br> {{ activity.remark }}
          </el-timeline-item>
        </el-timeline>
        <span slot="footer" class="dialog-footer">
          <el-button @click="progressVisible = false">取 消</el-button>
          <el-button type="primary" @click="progressVisible = false">确 定</el-button>
        </span>
      </el-dialog>


      <el-dialog title="发货" :visible.sync="dialogVisibleGoods" width="30%" :before-close="handleCloseGoods">
        <el-form :model="deliveryOfGoodsInfo" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="寄件人" prop="jcontact">
            <el-input v-model="deliveryOfGoodsInfo.jcontact"></el-input>
          </el-form-item>
          <el-form-item label="手机号(寄)" prop="jmobile">
            <el-input v-model="deliveryOfGoodsInfo.jmobile"></el-input>
          </el-form-item>
          <el-form-item label="货物内容" prop="depositumInfo">
            <el-input v-model="deliveryOfGoodsInfo.depositumInfo"></el-input>
          </el-form-item>
          <el-form-item label="货物数量" prop="depositumNo">
            <el-input v-model="deliveryOfGoodsInfo.depositumNo"
              onkeypress='return( /[\d]/.test(String.fromCharCode(event.keyCode)))'></el-input>
          </el-form-item>
          <el-form-item label="快件类型" prop="expressType">
            <el-select v-model="deliveryOfGoodsInfo.expressType" placeholder="请选择">
              <el-option label="顺丰特快" value="1"></el-option>
              <el-option label="顺丰标快" value="2"></el-option>
              <el-option label="顺丰即日" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="取件时间" prop="sendStartTime">
            <el-date-picker v-model="deliveryOfGoodsInfo.sendStartTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
              placeholder="选择日期时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="备注" prop="desc">
            <el-input type="textarea" v-model="deliveryOfGoodsInfo.remark"></el-input>
          </el-form-item>
          <el-checkbox :indeterminate="false" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
          <div style="margin: 15px 0;"></div>
          <el-checkbox-group v-model="isDeliveryOfGoodsList" @change="handleCheckedCitiesChange">
            <el-checkbox v-for="city in deliveryOfGoodsList" :label="city" :key="city.itemCode">{{ city.goodsName
            }}</el-checkbox>
          </el-checkbox-group>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="resetForm">取 消</el-button>
          <el-button type="primary" @click="submitForm">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import request from "../utils/request";
export default {
  data() {
    return {
      activities: {},
      checkAll: false,
      dialogVisibleGoods: false,
      deliveryOfGoodsList: [],
      isDeliveryOfGoodsList: [],
      deliveryOfGoodsInfo: {
        depositumInfo: '',
        expressType: '',
        jaddress: '山东省青岛市即墨区环秀街道燕青路37号',
        jcompany: '威达体育用品有限公司',
        jcontact: '',
        jmobile: '',
        jtel: '',
        remark: '',
        sendStartTime: '',
        depositumNo: ''
      },
      rules: {
        jcontact: [
          { required: true, message: '请输入寄件人姓名', trigger: 'blur' },
        ],
        jmobile: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { min: 11, max: 11, message: '请输入11位手机号码', trigger: 'blur' },
          {
            pattern: /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/,
            message: '请输入正确的手机号码'
          }
        ],
        depositumInfo: [
          { required: true, message: '请输入货物内容', trigger: 'blur' },
        ],
        depositumNo: [
          { required: true, message: '请输入发货数量', trigger: 'blur' },
        ],
        expressType: [
          { required: true, message: '请选择快件类型', trigger: 'change' },
        ],
        sendStartTime: [
          { required: true, message: '请选择快取件时间', trigger: 'change' },
        ],
      },
      info: {

      },
      tableData: [],
      dialogVisible: false,
      goodsInfo: {

      },
      progressVisible: false,
      orderCode: '',
      orderInfo: {
        isPage: true,
        orderCode: '',
        pageNum: 1,
        pageSize: 10
      },
      // 总条数
      total: 0
    };
  },
  created() {
    //console.log(this.$route.query);
    this.orderCode = this.$route.query.code
    this.orderInfo.orderCode = this.$route.query.code
    this.getDetails();
  },
  mounted() { },
  methods: {
    async showProgressBox(item) {
      const res = await request({
        method: "POST",
        url: 'admin/logistics/select/route',
        data: {
          // checkPhoneNo: item.consigneePhone.substring(7, 11),
          checkPhoneNo: '1670',
          trackingNumber: item.logisticsCode
        }
      })
      if (res.code === '200') {
        let data = JSON.parse(res.data)
        // console.log(data);
        let length = data[0].routes.length - 1
        // console.log(length);
        // return
        data[0].routes[length].color = '#54A8FD'
        this.activities = data[0]
        this.progressVisible = true
      } else {
        this.$message.error(res.message)
      }
    },
    deliveryOfGoods() {
      this.deliveryOfGoodsInfo.remark = ''
      if (this.$refs['ruleForm'] !== undefined) {
        this.$refs['ruleForm'].resetFields();
      }
      this.isDeliveryOfGoodsList = []
      this.checkAll = false
      let data = []
      this.tableData.forEach(item => {
        if (item.logisticsCode === null) {
          data.push(item)
        }
      })
      if (data.length > 0) {
        this.deliveryOfGoodsInfo.batchId = data[0].batchId
        this.deliveryOfGoodsInfo.orderCode = data[0].orderCode
        this.deliveryOfGoodsList = data
        this.dialogVisibleGoods = true
      } else {
        this.$message.error("该订单已经全部发货")
      }

    },
    handleCheckAllChange(val) {
      this.isDeliveryOfGoodsList = val ? this.deliveryOfGoodsList : [];
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.deliveryOfGoodsList.length;
    },
    submitForm() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          if (this.isDeliveryOfGoodsList.length > 0) {
            this.submitForDelivery()
          } else {
            this.$message.error('请选择货物')
          }
        } else {
          return false;
        }
      });
    },
    resetForm() {
      this.$refs['ruleForm'].resetFields();
      this.dialogVisibleGoods = false
    },
    submitForDelivery() {
      let orderItemCodeList = []
      this.isDeliveryOfGoodsList.forEach(item => {
        orderItemCodeList.push(item.itemCode)
      })
      this.deliveryOfGoodsInfo.orderItemCodeList = orderItemCodeList
      this.dialogVisibleGoods = false
      request({
        method: "POST",
        url: 'admin/logistics/sf/order',
        data: this.deliveryOfGoodsInfo
      }).then(res => {
        if (res.code === '200') {
          this.$message.success(res.message)
          this.orderInfo.pageNum = 1
          this.getDetails();
        }
      }).catch()
    },
    //分页
    handleCurrentChange() {
      this.getDetails()
    },
    // 返回上一页
    returnPage() {
      this.$router.go(-1)
    },
    // 查询订单信息
    async getDetails() {
      const res = await request({
        method: "POST",
        url: `admin/order/getOrderDetail`,
        data: this.orderInfo
      });

      //console.log(res);
      if (res.code === '200') {
        this.info = res.data && JSON.parse(res.data.list[0].studentInfoRes)
        this.tableData = res.data && res.data.list
        // console.log(this.tableData);
        this.total = res.data.total
      }
    },

    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          done();
        })
        .catch(() => { });
    },
    handleCloseGoods(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          this.$refs['ruleForm'].resetFields();
          done();
        })
        .catch(() => { });
    },
    // 打开弹窗
    openDialog(val) {
      this.goodsInfo = Object.assign({}, val)
      this.dialogVisible = true
    },
    // 确认修改
    async confirmModification() {
      const res = await request({
        method: 'GET',
        url: `admin/order/updOrderRemark?orderItemId=${this.goodsInfo.id}&remark=${this.goodsInfo.remark}`
      })
      //console.log(res);
      if (res.code === '200') {
        this.$message.success(res.message)
        this.dialogVisible = false
        this.getDetails(this.orderCode)
      } else {
        this.$message.error(res.message)
      }
    }
  }

};
</script>

<style lang="scss" scoped>
.list {
  background-color: #2589ff;
  color: #fff;
  text-align: center;
  width: 106px;
  height: 36px;
  margin-right: 10px;
  font-size: 16px;
  line-height: 36px;
  display: inline-block;
  border-radius: 6px;
}

.content {
  margin: 20px 0 0 0;
  background-color: #e0e0e0;
  padding: 10px;
  border-radius: 5px;
}

.goods {
  background-color: #fff;
  border-radius: 5px;
  padding: 10px 20px;
  //display: flex;
  //justify-content: space-between;
}

.search {
  display: flex;
  flex-wrap: wrap;

  div {
    margin-bottom: 10px;
  }
}

.block {
  background-color: #fff;
  text-align: right;
}
</style>